import poll from "./poll";
import Fetcher from "../fetcher";
import validate from "./validate";
import aggregateChargeData from "./data";
import encrypt from "../utils/encryption";
import { USES_CHARGE_POLLING } from "./flags";
import { parseChargeCallbacks } from "./utils";
import handleChargeResponse from "./handler/charge";
import { callback, withProperties, noop } from "../utils";
import { DEFAULT_POST_INIT, isJsonResponse, withSharedHeaders } from "../fetcher/utils";
import { CHECKOUT_CLOSE_EVENT } from "../context/helpers/tokens";
import Store from "../context";
import { getValueAtPath } from "../utils";

let hasClosedCheckout = false;
let listening = false;
const $fetcher = withSharedHeaders(Fetcher.one.init(DEFAULT_POST_INIT));

function startListeningForCancellation() {
  if (listening !== true) {
    addEventListener(CHECKOUT_CLOSE_EVENT, cancellationListener, false);

    listening = true;
  }
}

function stopListeningForCancellation() {
  if (listening === true) {
    removeEventListener(CHECKOUT_CLOSE_EVENT, cancellationListener, false);

    listening = false
  }
}

function cancellationListener() {
  stopListeningForCancellation();
  hasClosedCheckout = true;
}

function __getChargeEndpoint__() {
  const usePolling = Boolean(this.flags & USES_CHARGE_POLLING);
  const endpoint = new URL('/flwv3-pug/getpaidx/api/charge', process.env.API_BASE_URL);

  if (usePolling === true) {
    endpoint.searchParams.set('use_polling', 1);
  }

  return endpoint;
}

export default function __charge__(data, callbacks) {
  startListeningForCancellation();
  const $this = this;
  let { onBegin, onComplete, onError } = (callbacks = parseChargeCallbacks(callbacks));
  onBegin = callback(onBegin);
  onComplete = callback(onComplete);
  onError = callback(onError, noop /* console.error */);

  if (getValueAtPath(Store.getState(), 'session.expired') === true) {
    onError.call($this, new Error('charge.session.expired'));
    onComplete.call($this);
    return Promise.resolve();
  }

  const handleResponse = handleChargeResponse.bind(
    withProperties(Object.create(null), { ...callbacks })
  );
  return aggregateChargeData.call($this, data)
    .then(($chargedata) => {
      onBegin.call($this);
      // console.log($chargedata);

      const requestBody = JSON.stringify({
        modalauditid: $chargedata.modalauditid,
        PBFPubKey: $chargedata.PBFPubKey,
        client: encrypt($chargedata)
      });

      // Final expiry check immediately before the request leaves the client.
      // Nothing async runs between here and fetch(), so this is the last
      // point we can abort without a request going out on an expired session.
      if (getValueAtPath(Store.getState(), 'session.expired') === true) {
        onError.call($this, new Error('charge.session.expired'));
        onComplete.call($this);
        return Promise.resolve();
      }

      return $fetcher(__getChargeEndpoint__.call($this), {
        body: requestBody
      })
        .then(response => {
          if (hasClosedCheckout === false) {
            if (isJsonResponse(response)) {
              /* if (response.ok) */return response.json().then(handleResponse);
            }
          }
          return Promise.reject(new Error);
        })
        .catch(onError)
        .finally(onComplete.bind($this));
    });
}

export { poll, validate, $fetcher };
